import { createContext, useContext } from "react";

const RelativeContainerContext = createContext<null | HTMLDivElement>(null);

export const RelativeContainerContextProvider = RelativeContainerContext.Provider;

export const useClosestRelativeContainer = (): null | HTMLDivElement => useContext(RelativeContainerContext);
